export default __webpack_public_path__ + "static/media/little_girl.754bf2cd.png";